import { Route, Routes } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { OnboardingPage } from './pages/OnboardingPage';
import { SearchPage } from './pages/SearchPage';
import { EditTab } from './pages/patient/EditTab';
import { EncounterChart } from './pages/encounter/EncounterChart';
import { EncounterModal } from './pages/encounter/EncounterModal';
import { PatientPage } from './pages/patient/PatientPage';
import { PatientSearchPage } from './pages/patient/PatientSearchPage';
import { TimelineTab } from './pages/patient/TimelineTab';
import { ResourceDetailPage } from './pages/resource/ResourceDetailPage';
import { ResourceEditPage } from './pages/resource/ResourceEditPage';
import { ResourceHistoryPage } from './pages/resource/ResourceHistoryPage';
import { QuestionnairePreviewPage } from './pages/resource/QuestionnairePreviewPage';
import { ResourcePage } from './pages/resource/ResourcePage';
import { CommunicationTab } from './pages/patient/CommunicationTab';
import { TaskTab } from './pages/patient/TaskTab';
import { UploadDataPage } from './pages/UploadDataPage';
import { SourceDocumentPage } from './pages/resource/SourceDocumentPage';
import { ResourceLang2FHIRCreatePage } from './pages/resource/ResourceLang2FHIRCreatePage';
import { CreateCohortPage } from './pages/resource/CreateCohortPage';
import { TaskDetails } from './pages/tasks/TaskDetails';
import { ResourceCreatePage } from './pages/resource/ResourceCreatePage';
import { CaptureUploadPage } from './pages/capture/CaptureUploadPage';
import { CaptureSessionPage } from './pages/capture/CaptureSessionPage';

export function Router(): JSX.Element {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/Patient/:patientId" element={<PatientPage />}>
        <Route path="Encounter/new" element={<EncounterModal />} />
        <Route path="Encounter/:encounterId" element={<EncounterChart />}>
          <Route path="Task/:taskId" element={<TaskDetails />} />
        </Route>
        <Route path="edit" element={<EditTab />} />
        <Route path="communication" element={<CommunicationTab />} />
        <Route path="communication/:id" element={<CommunicationTab />} />
        <Route path="task/:id/*" element={<TaskTab />} />
        <Route path="timeline" element={<TimelineTab />} />
        <Route path="capture" element={<CaptureUploadPage />} />
        <Route path="capture/:sessionId" element={<CaptureSessionPage />} />
        <Route path=":resourceType" element={<PatientSearchPage />} />
        <Route path=":resourceType/new" element={<ResourceCreatePage />} />
        <Route path=":resourceType/new/lang2fhir" element={<ResourceLang2FHIRCreatePage />} />
        <Route path=":resourceType/:id" element={<ResourcePage />}>
          <Route path="" element={<ResourceDetailPage />} />
          <Route path="edit" element={<ResourceEditPage />} />
          <Route path="history" element={<ResourceHistoryPage />} />
          <Route path="preview" element={<QuestionnairePreviewPage />} />
          <Route path="source" element={<SourceDocumentPage />} />
        </Route>
        <Route path="" element={<TimelineTab />} />
      </Route>
      <Route path="Task/:id/*" element={<TaskTab />} />
      <Route path="/onboarding" element={<OnboardingPage />} />
      <Route path="/:resourceType" element={<SearchPage />} />
      <Route path="/:resourceType/new" element={<ResourceCreatePage />} />
      <Route path=":resourceType/new/lang2fhir" element={<ResourceLang2FHIRCreatePage />} />
      <Route path="/:resourceType/:id" element={<ResourcePage />}>
        <Route path="" element={<ResourceDetailPage />} />
        <Route path="edit" element={<ResourceEditPage />} />
        <Route path="history" element={<ResourceHistoryPage />} />
        <Route path="preview" element={<QuestionnairePreviewPage />} />
        <Route path="source" element={<SourceDocumentPage />} />
      </Route>
      <Route path="/upload/:dataType" element={<UploadDataPage />} />
      <Route path="create-cohort" element={<CreateCohortPage />} />
    </Routes>
  );
}